import React from "react"
import ReactMarkdown from "react-markdown"
import styled from "styled-components"

import { color, mixin } from "~/libs/style"

export const Markdown: React.FC<{ source: string }> = ({ source }) => (
  <MarkdownWrapper>
    <StyledMarkdown source={source} escapeHtml={false} />
  </MarkdownWrapper>
)

const MarkdownWrapper = styled.div`
  margin: 10px 10px 30px;
`

const StyledMarkdown = styled(ReactMarkdown)`
  line-height: 1.6;
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 20px;
    font-weight: bold;
    line-height: 1.3;
    color: ${color.dimGray};
  }
  h2,
  h3,
  h4 {
    font-size: 17px;
  }
  h2 {
    padding: 10px;
    margin: 30px -10px 20px;
    background-color: ${color.whiteSmoke};
  }
  h3 {
    padding: 3px 5px;
    border-left: 4px solid ${color.dimGray};
  }

  p {
    margin-bottom: 20px;
  }

  blockquote {
    padding-left: 5px;
    color: ${color.dimGray};
    border-left: 5px solid ${color.choke};
  }

  pre,
  code {
    background-color: ${color.whiteSmoke};
    border: 1px solid ${color.orchidGray};
  }
  code {
    padding: 0.1em 0.3em;
    margin: 0 2px;
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    font-size: 13px;
    border-radius: 2px;
  }
  pre {
    ${mixin.borderRadius}
    padding: 10px;
    margin-bottom: 20px;
    overflow: auto;
    code {
      padding: 0;
      background-color: transparent;
      border: none;
    }
  }

  hr {
    height: 1px;
    margin: 20px 0;
    border: none;
    border-top: 1px solid ${color.lightGray};
  }

  ul {
    margin-bottom: 20px;
    li {
      padding-left: 1em;
      margin: 3px 0;
      text-indent: -1em;
      &::before {
        display: inline-block;
        width: 1em;
        height: 1em;
        vertical-align: text-top;
        content: "";
        background-image: radial-gradient(0.13em 0.13em at center center, ${color.inkBlack} 90%, transparent);
      }
    }
  }
  ol {
    margin-bottom: 20px;
    li {
      margin: 3px 0 3px 1.7em;
      list-style: decimal;
    }
  }
  ul > li > ul,
  ul > li > ol,
  ol > li > ul,
  ol > li > ol {
    margin-bottom: 0;
  }

  a {
    color: ${color.blue};
  }
  a:visited {
    color: ${color.purple};
  }
  a:link {
    color: ${color.blue};
  }
  a:active {
    color: ${color.blue};
  }

  em {
    font-style: italic;
  }
  strong {
    font-weight: bold;
  }

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }

  table {
    display: block;
    margin-bottom: 20px;
    overflow-x: scroll;
    border-spacing: 0;
    border-left: 1px solid ${color.orchidGray};
    -webkit-overflow-scrolling: touch;
  }
  th {
    font-weight: bold;
    white-space: nowrap;
    background-color: ${color.whiteSmoke};
  }
  th,
  td {
    padding: 3px 5px;
    border-right: 1px solid ${color.orchidGray};
    border-bottom: 1px solid ${color.orchidGray};
  }
  tr:first-child th,
  tr:first-child td {
    border-top: 1px solid ${color.orchidGray};
  }
`
